module.exports = __webpack_public_path__ + "src/assets/img/3.ae9f132e.jpg";